<template>
<div class="page page_iteminfo page_co">
	<!--  代理商 -->
   <div class="jiangren" v-if="status == 0 && agentList ">
		<div class="con" v-for="(agent,index) in agentList" :key="index">
			<div class="con_info">
				<div class="thumb" v-if="agent.user">
					<img :src="agent.user.thumb ? ($publicData.withHttpStart(agent.user.thumb) ? agent.user.thumb : imageUrl+agent.user.thumb) : $publicData.defaultTouxiang" alt="" class="">
				</div>
				<div class="name" v-if="agent.user">{{ agent.user.nickname }}</div>
			</div>
		</div>
	</div>
	<!-- 合伙人 一个-->
	<div class="jiangren" v-if="status == 1 && partner">
		<div class="con">
			<div class="con_info">
				<div class="thumb">
					<img :src="partner.userdata.thumb ? ($publicData.withHttpStart(partner.userdata.thumb) ? partner.userdata.thumb :imageUrl+partner.userdata.thumb) : $publicData.defaultTouxiang" alt="" class="">
				</div>
				<div class="name">{{ partner.userdata.nickname }}</div>
			</div>
		</div>
	</div>
	<!-- 无分销商 -->
	<div class="page_default" v-if="status == 0 && !agentList">
		<div class="bg">
			<img :src="publicPath+'statics/images/no_member.png'" alt="" class="tu">
		</div>
		<div class="tips">暂无分销商</div>
	</div>
	<!-- 无合伙人 -->
	<div class="page_default" v-if="status == 1 && !partner">
		<div class="bg">
			<img :src="publicPath+'statics/images/no_member.png'" alt="" class="tu">
		</div>
		<div class="tips">暂无合伙人</div>
	</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			token: '',
			status: this.$route.query.status, // 0 是分销商，1是合伙人
			agentList: null, //
			partner: null
        };
    },
    created: function () {
		
    },
    mounted: function () {
		console.log('mounted')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '我的分销商',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
			// 获取列表
			this.getData()
        }

    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
            }
            this.$api.tradesman.getAgentsAndPartners(params).then(res => {
                if (res.code == 200) {
					// 代理商
					this.agentList = res.result.agent
					console.log('this.agentList',this.agentList)
					var list = res.result.agent
					if(list.length != 0){
						this.agentList = list
					}
					// 合伙人
					this.partner = res.result.partner
                } else {
                    this.$toast(res.message)
                }
            })
        },   
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
